<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in" [innerHTML]="modalData.title"></h4>
</div>

<div class="modal-body">
    <div class="row" *ngIf="modalData.type === 'notes'">
        <app-notes-and-communication [jobMatchId]="modalData.jobMatchId" type="notes"
            [candidateInformationList]="modalData.candidateInformationList" [candidateDetails]="modalData.candidateDetails"
            sourceScreen="CANDIDATE" [companyDetails]="modalData.companyDetails">
        </app-notes-and-communication>
    </div>

    <div class="row" *ngIf="modalData.type === 'communication-candidate'">
        <app-notes-and-communication [jobMatchId]="modalData.jobMatchId" type="communication"
            [candidateInformationList]="modalData.candidateInformationList">
        </app-notes-and-communication>
    </div>

    <div class="row" *ngIf="modalData.type === 'communication-peer'">
        <app-user-communication [candidateId]="modalData.candidateId" [jobId]="modalData.jobId"
            [jobMatchId]="modalData.jobMatchId" [jobMatchesFilter]="modalData.jobMatchesFilter" context="candidateCard"
            [candidateInformationList]="modalData.candidateInformationList">
        </app-user-communication>
    </div>

    <div class="row" *ngIf="modalData.type === 'activities'">
        <app-entity-activities [candidateId]="modalData.candidateInfo.id" [candidateName]="modalData.candidateInfo.name"
            [activityMap]="modalData.activityMap" context="candidate">
        </app-entity-activities>
    </div>

    <div class="row" *ngIf="modalData.type === 'availability'">
        <div class="col-xs-12">
            <app-set-candidate-availability-or-job-left-date [candidateId]="modalData.candidateId"
                availabilityType="availability" [availabilityDate]="modalData.availabilityDate"
                [joinedDate]="modalData.joinedDate" (saveCallback)="saveCallback()">
            </app-set-candidate-availability-or-job-left-date>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'jobLeft'">
        <div class="col-xs-12">
            <app-job-left [jobId]="modalData.bestMatchJobId" [candidateId]="modalData.candidateId"
                (saveCallback)="saveCallback()" (cancelCallback)="closeModal()">
            </app-job-left>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'delete'">
        <div class="col-xs-12">
            <app-delete-entity entity="candidate" [candidateInfo]="modalData.candidateInfo"
                (deleteCallback)="deleteCallback()" (cancelCallback)="closeModal()" sourceScreen="CANDIDATE"
                [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-delete-entity>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'updateContact'">
        <div class="col-xs-12">
            <app-add-edit-candidate-contact [candidateId]="modalData.candidateId" (saveCallback)="saveCallback()"
                (cancelCallback)="closeModal()">
            </app-add-edit-candidate-contact>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'bestMatchJobProfile'">
        <div class="col-xs-12">
            <app-job-profile [jobId]="modalData.bestMatchJobId"></app-job-profile>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'uploadResume'">
        <div class="col-xs-12">
            <app-add-candidates [singleUploadResume]="true" [candidateId]="modalData.candidateId"
                [sourceScreen]="'CANDIDATE'" [formalizeActivityPayload]="modalData.formalizeActivityPayload"
                (saveCallback)="saveCallback()">
            </app-add-candidates>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'doNotHire'">
        <div class="col-xs-12">
            <app-do-not-hire [candidateId]="modalData.candidateId" [jobId]="modalData.bestMatchJobId"
                (cancelCallback)="closeModal()" (saveCallback)="saveCallback()" sourceScreen="CANDIDATE"
                [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-do-not-hire>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'clientReview'">
        <app-email-client-review context="candidateCard" [clientReviewDetails]="true" (cancelCallback)="closeModal()"
            (saveCallback)="saveCallback()" [candidateId]="modalData.candidateId">
        </app-email-client-review>
    </div>

    <div class="row" *ngIf="modalData.type === 'profile'">
        <div class="col-xs-12">
            <app-candidate-job-match-profile *ngIf="modalData.bestMatchJobId == ''"
                [candidateId]="modalData.candidateId" context="candidateCard"
                [candidateType]="modalData.candidateDetails.candidateType" [candidateDetails]="modalData.candidateDetails"
                sourceScreen="CANDIDATE" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-candidate-job-match-profile>
            <app-candidate-job-match-profile *ngIf="modalData.bestMatchJobId !== ''"
                [jobMatchId]="modalData.bestJobMatchId" [jobId]="modalData.bestMatchJobId"
                [candidateId]="modalData.candidateId" [candidateType]="modalData.candidateDetails.candidateType"
                context="candidateJobMatchCard" [candidateDetails]="modalData.candidateDetails"
                sourceScreen="CANDIDATE" [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-candidate-job-match-profile>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'emailDocument'">
        <div class="col-xs-12">
            <app-email-documents context="candidateCard" [candidateDetails]="modalData.candidateDetails"
                (saveCallback)="saveCallback()" (cancelCallback)="closeModal()" sourceScreen="CANDIDATE"
                [formalizeActivityPayload]="modalData.formalizeActivityPayload">
            </app-email-documents>
        </div>
    </div>

    <div class="row" *ngIf="modalData.type === 'sendOutreach'">
        <div class="col-xs-12">
            <app-send-candidate-outreach-email [companyId]="modalData.companyId" [userId]="modalData.userId"
                [candidateId]="modalData.candidateId" [clientOrBuId]="modalData.clientOrBUId" context="candidateCard"
                (closeCallback)="closeModal()" [isOutreachModal]="true" [jobMatches]="modalData.jobMatches"
                [candidateType]="modalData.candidateType" (successCallback)="saveCallback()"
                [salaryDurationOptions]="modalData.salaryDurationOptions" [jobTypeList]="modalData.jobTypeList">
            </app-send-candidate-outreach-email>
        </div>
    </div>
</div>
